module.exports = __webpack_public_path__ + "img/-LV55bMSzZghYL1BG-G2.92204475.jpg";